import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';

export function bigNumberMinValidator(minValue: number, text = ''): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const textRegex = new RegExp(text, 'g');
        const value = +`${control.value}`.replace(/\s/g, '').replace(textRegex, '');
        const aboveMin = value === null || value >= minValue;

        return aboveMin ? null : { min: minValue };
    };
}
